import { createContext } from 'react'

export type GuardedNavigate = (path: string) => void

export interface NavigationGuardContextValue {
  /**
   * When a page has unsaved work it registers its own navigate here (the flow editor's
   * `guardNavigate`, which opens the unsaved-changes modal while the draft is dirty). The top
   * bar's Back button routes through it instead of plain `navigate`, so the page keeps its guard
   * without drawing a second Back button of its own. `null` when no page has registered one.
   */
  guardedNavigate: GuardedNavigate | null
  setGuardedNavigate(guardedNavigate: GuardedNavigate | null): void
}

export const NavigationGuardContext = createContext<NavigationGuardContextValue>({
  guardedNavigate: null,
  setGuardedNavigate: () => {},
})
